import { jsx as _jsx } from "react/jsx-runtime";
import { IsShariaComponent } from "generated/generated-models";
export const CLoanWord = () => {
    return (_jsx(IsShariaComponent, { children: ({ data }) => (_jsx("span", { children: shariaRentText((data &&
                data.userSession &&
                data.userSession.IsSharia) ||
                false) })) }));
};
const shariaRentText = (isSharia) => {
    return (isSharia && "Rental") || "Loan";
};
